import axios from 'axios';

import ReportsService from '../../../services/api/reports';

const reportsService = new ReportsService({});

const uploadFileForTemplate = async ({ fields, id }) => {
  if (fields) {
    const upload = async ({ field, type }) => {
      const filePayload = new FormData();
      filePayload.append('type', type);
      filePayload.append('file', field.file);
      filePayload.append('key', field.id);
      await axios.put(`/api/v1/tickets/templates/${id}/file`, filePayload, { headers: { 'Content-Type': 'multipart/form-data' } });
    };
    for (const key in fields) {
      const currentField = fields[key];
      await upload({ field: currentField, type: 'field' });
    }
  }
};

export default {
  get: (params) => axios.get('/api/v1/tickets/templates', { params }),
  getById: (id) => axios.get(`/api/v1/tickets/templates/${id}`),
  create: async (params) => {
    const { payload, reports: { fields } } = reportsService.mapTemplatePayload(params, false, true);
    const { id } = await axios.post('/api/v1/tickets/templates', payload);
    await uploadFileForTemplate({ fields, id });
  },
  update: async (params, id) => {
    const { payload, reports: { fields } } = reportsService.mapTemplatePayload(params, false, true);
    await axios.put(`/api/v1/tickets/templates/${id}`, payload);
    await uploadFileForTemplate({ fields, id });
  },
  delete: (params) => axios.delete('/api/v1/tickets/templates', { params }),
  exportTemplate: (params) => axios.post('/api/v1/tickets/templates/export', params),
  importTemplate: (params) => axios.post('/api/v1/tickets/templates/import', params),
};
